module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAARVBMVEUAAAAiHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx9LxjSRAAAAFnRSTlMAgBCQwenQaogFyJcfDejgs76iSSmppyJlkwAAALlJREFUOMvVk9kKwjAQRSfLZOmi1db7/59q2rSOGGwoFMTzcsPlQGYIoQwjwZGEsiE4Yxro3YZgiBT0t4axcCMasPLZMKExCdyJWrRGkMaBoGrXmZe00IsjjUjeJLwo0oi0wwHJqgoNCHWOzuSnnOOYc/Kl1G8H63Iq9IWkS0m/S14lwrbm9ZLTIszhV4mxA69S1IkOQS9YlzOgmyMemKki/WC76nX/vt3JbxfZ58NjyOk50vn/jlGFn52OIBma4uwlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-calendar.png
// module id = 3HfQ
// module chunks = 2